<template lang="pug">
table.release_note
  tr
    td.type {{title}}
  tr(v-if='!hasBr')
    td.content {{computedContent}}
  tr(v-for='($index, s) in computedContent' track-by="$index" v-else)
    td.content {{s}}
</template>
<script>
export default {
  props: {
    title: {
      type: String
    },
    content: {
      type: String
    },
    class: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
    uniContent () {
      return this.content.replace(/\r\n|\n\r|\r/, '\n')
    },
    hasBr () {
      return this.uniContent.indexOf('\n') !== -1
    },
    computedContent () {
      if (!this.hasBr) {
        return this.uniContent
      } else {
        return this.uniContent.split('\n')
      }
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.type {
  color: #888;
  width: 85px;
}
.content{
  padding-left: 30px;
}
tr{
  display: table; // for firefox
}

.release_note{
  text-align: left;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// LinedTable.vue?39c3637e